import { action } from 'typesafe-actions';
import { PORTAL_TYPES, KnowledgePortals } from './types';

export const getKnowledgePortalAction = (payload?: any) =>
  action(PORTAL_TYPES.GET_KNOWLEDGE_PORTAL_REQUEST, payload);

export const setKnowledgePortalAction = (data: KnowledgePortals) =>
  action(PORTAL_TYPES.SET_DATA_KNOWLEDGE_PORTAL, data);

export const setError = (error: any) => action(PORTAL_TYPES.SET_ERROR, error);
